import {cn} from '@sollapay/ui';
import {useId} from 'react';

import {TrustAccountStatusGroupHeader} from './TrustAccountStatusGroupHeader';
import {
  TRUST_ACCOUNT_GRID_CARD_CONTAINER_CLASS,
  TRUST_ACCOUNT_GRID_CARD_GRID_CLASS
} from '../config';

import type {TrustStatus} from '@sollapay/enums';
import type {FC, ReactNode} from 'react';

export interface TrustAccountStatusSectionProps {
  status: TrustStatus;
  count: number;
  isCollapsed?: boolean;
  /** Omit for a section that can't be folded. */
  onToggle?: () => void;
  children: ReactNode;
}

/** One status group of the card grid: its header, then its cards. */
export const TrustAccountStatusSection: FC<TrustAccountStatusSectionProps> = ({
  status,
  count,
  isCollapsed = false,
  onToggle,
  children
}) => {
  const panelId = useId();

  return (
    <section
      data-slot="trust-account-status-section"
      className={cn(TRUST_ACCOUNT_GRID_CARD_CONTAINER_CLASS, 'flex flex-col gap-3.5')}
    >
      <TrustAccountStatusGroupHeader
        variant="section"
        status={status}
        count={count}
        isCollapsed={isCollapsed}
        onToggle={onToggle}
        controlsId={panelId}
      />
      <div id={panelId} hidden={isCollapsed} className={TRUST_ACCOUNT_GRID_CARD_GRID_CLASS}>
        {children}
      </div>
    </section>
  );
};
